import { Injectable } from "@angular/core";
import gql from "graphql-tag";
import { Apollo } from "apollo-angular";

@Injectable()
export class TagService {
  constructor(private apollo: Apollo) {}

  list(obj?) {
    let variables = {};
    console.log("tagInfo", obj);
    if (obj) {
      variables = {
        first: obj.paginationData.pageSize,
        after:
          obj.paginationData.after === undefined
            ? null
            : obj.paginationData.after.endCursor, // Use after for pagination cursor
        searchParam: obj.searchParam || "", // Include searchParam
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetTags($first: Int, $after: String, $searchParam: String) {
          tags(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                id
                name
                slug
                faqs {
                  id
                  title
                }
              }
            }
            totalCount
          }
        }
      `,
      variables: variables, // Pass variables here
      fetchPolicy: "network-only", // Ensure fresh data is fetched from the network
      errorPolicy: "all", // Capture and report any GraphQL errors
    }).valueChanges;
  }

  create(obj) {
    obj.slug = " ";
    return this.apollo.mutate({
      mutation: gql`
        mutation createTag($name: String!, $slug: String!) {
          createTag(tag: { name: $name, slug: $slug }) {
            id
          }
        }
      `,
      variables: {
        name: obj.name,
        slug: obj.slug,
      },
    });
  }

  read(id: string) {
    return this.apollo.watchQuery({
      query: gql`
        {
          tag(id: "${id}") {
            id
            name
            slug
            faqs {
              id
              title
            }
          }
        }
      `,
    }).valueChanges;
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateTag($id: String!, $name: String!, $slug: String) {
          updateTag(tag: { id: $id, name: $name, slug: $slug }) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        name: obj.name,
        slug: obj.slug,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeTag {
          removeTag(tag: {id: "${obj.id}"}) {
            success
          }
        }
      `,
    });
  }
  listFaqForAutocomplete(obj?) {
  let filters = "";
  if (obj) {
    filters = `(
      first: ${obj.paginationData.pageSize},
      after: "${obj.paginationData.pageSize * obj.paginationData.pageIndex}",
      searchParam: "${obj.searchParam || ""}"
    )`;
  }
  return this.apollo.watchQuery({
    query: gql`
      {
        tags ${filters} {
          edges {
            node {
              id
              name
              slug
            }
          }
          totalCount
        }
      }
    `,
  }).valueChanges;
}
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/tag.service.ts